/*
 * c_reveal.js
 * 見出し行アニメーション（マスクリビール）の共通発火制御。
 * .c_reveal 要素を監視し、画面内に入ったら is-anim → is-inview を付与する。
 * ベースCSSは c_theme.css（.c_reveal__line 系）、マークアップは snippets/c_reveal-title.liquid。
 * - 発火位置は各要素の data-reveal-margin（rootMargin）で個別調整可。既定は下から 25%
 */
(function () {
  'use strict';

  const DEFAULT_MARGIN = '0px 0px -25% 0px';

  function initReveal(scope) {
    const root = scope || document;
    const els = root.querySelectorAll('.c_reveal:not([data-reveal-ready])');
    els.forEach(function (el) {
      el.setAttribute('data-reveal-ready', '');

      // 初期状態（各行を隠す）を適用
      el.classList.add('is-anim');

      const margin = el.getAttribute('data-reveal-margin') || DEFAULT_MARGIN;
      const reveal = function () {
        el.classList.add('is-inview');
      };

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      const io = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal();
              observer.disconnect();
            }
          });
        },
        { threshold: 0, rootMargin: margin }
      );
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal(document);
    });
  } else {
    initReveal(document);
  }

  // Shopify テーマエディタでセクションが再描画されたら再初期化
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });
})();
